import React from 'react';
import { Dumbbell } from 'lucide-react';

export default function Brand({ light = false }) {
  return (
    <a href="/" className={`flex select-none items-center gap-2.5 ${light ? 'text-white' : 'text-[#10130f]'}`}>
      <span className="grid h-9 w-9 place-items-center rounded-xl bg-[#d8ff63] text-[#10130f]">
        <Dumbbell size={19} strokeWidth={2.7} />
      </span>
      <span className="text-[1.15rem] font-black tracking-[-0.03em]">FITMAISTER</span>
    </a>
  );
}
